import { APP_VERSION_RESTAURANT } from './types';
import _ from "lodash";

const LOCAL_CONSTANT = {
    PRIVILEGE_ATTERIBUTE: "privilegeAttribute",
    GROUP: "GROUP",
}

export const setAppVersionRestaurantDefault = () => {
    return {
        type: APP_VERSION_RESTAURANT.SET_APP_VERSION_RESTAURANT_DEFAULT,
    }
}

export const setAppVersionRestaurant = (appVersionRestaurant) => {
    return {
        type: APP_VERSION_RESTAURANT.SET_APP_VERSION_RESTAURANT,
        appVersionRestaurant: appVersionRestaurant
    }
}

export const setAppVersionRestaurantValue = (draftType, orignalProduct, key, value, index) => {
    const appVersionRestaurant = _.cloneDeep(orignalProduct);
    appVersionRestaurant[draftType] = value;
    
    return {
        type: APP_VERSION_RESTAURANT.SET_APP_VERSION_RESTAURANT_VALUE,
        appVersionRestaurant: appVersionRestaurant
    }
}
